import {Directive, HostListener, HostBinding, EventEmitter, Output} from '@angular/core';

@Directive({
	selector: '[appDnd]'
})
export class DndDirective {
	@Output() private filesChangeEmitter : EventEmitter<File> = new EventEmitter();
	@Output() private filesInvalidEmitter : EventEmitter<string> = new EventEmitter();
	@HostBinding('style.background') private background = '#fff';

	constructor() { }

	@HostListener('dragover', ['$event']) public onDragOver(evt: any): void{
		evt.preventDefault();
		evt.stopPropagation();
		this.background = '#eee';
	}

	@HostListener('dragleave', ['$event']) public onDragLeave(evt: any): void{
		evt.preventDefault();
		evt.stopPropagation();
		this.background = '#fff'
	}

	@HostListener('drop', ['$event']) public onDrop(evt: any): void{
		evt.preventDefault();
		evt.stopPropagation();
		this.background = '#fff';
		
		let files = evt.dataTransfer.files;

		if(files.length === 1){
			let file: File = files[0];
			let pattern = /image-*/;

			if(file.type.match(pattern)){
				let validFile : File = files[0];
				this.filesChangeEmitter.emit(validFile);
			}else{
				this.filesInvalidEmitter.emit("File extension is invalid!");
			}
		} else if(files.length === 0){
			this.filesInvalidEmitter.emit("No valid file has dropped!");
		} else {
			this.filesInvalidEmitter.emit("Only one file is droppable here!");
		}
	}
}